const DubbingIcon = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.5 12H16v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-8a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v8a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-8a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V12H3.5a8.5 8.5 0 0017 0zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default DubbingIcon;
